import { render } from "./BlockEnderecoSocio.vue?vue&type=template&id=f9f3bc1a"
import script from "./BlockEnderecoSocio.vue?vue&type=script&lang=js"
export * from "./BlockEnderecoSocio.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/CampoForm/components/BlockEnderecoSocio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f9f3bc1a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f9f3bc1a', __exports__)) {
    console.log('reload')
    api.reload('f9f3bc1a', __exports__)
  }
  
  module.hot.accept("./BlockEnderecoSocio.vue?vue&type=template&id=f9f3bc1a", () => {
    console.log('re-render')
    api.rerender('f9f3bc1a', render)
  })

}


export default __exports__